import React, { useEffect, useState } from "react";
import { BlockSkeleton } from "../../interfaccia/loading";
import ImgArt from "../AreaOrdiniComponenti/OrdineComponenti/ImgArt";

function IconaArticolo() {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" aria-hidden="true"><path d="m8 3-6 4 3 5 3-2v11h8V10l3 2 3-5-6-4a4 4 0 0 1-8 0Z"/></svg>;
}

export function GuidaScansione({ prodotto, sospesa, inCoda }) {
  return <div className={`mag-scan-guide${prodotto ? " mag-scan-guide-product" : ""}`}>
    <div className="mag-scan-icons" aria-hidden="true">
      <svg className="mag-scan-box" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"><path d="m12 2 9 5v10l-9 5-9-5V7Z M3 7l9 5 9-5 M12 12v10 M7.5 4.5l9 5v4"/></svg>
      <svg className="mag-scan-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12h18m-7-7 7 7-7 7"/></svg>
      <div className="mag-scan-product"><IconaArticolo/></div>
    </div>
    <p className="mag-scan-instruction" role="status">{sospesa ? "Lettura in pausa" : inCoda ? "Elaborazione letture in coda…" : prodotto ? "Ora scansiona l’articolo" : "Scansiona la prenotazione"}</p>
  </div>;
}

// Montato con key sessione + ID lettura: nessuna anteprima può passare al pezzo successivo.
export function AnteprimaArticolo({ api, sessioneId, barcode }) {
  const [articolo, setArticolo] = useState(null);
  const [errore, setErrore] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    const timeout = setTimeout(() => { controller.abort(); setErrore(true); }, 6000);
    api("get", `/sessioni/${sessioneId}/anteprima`, { barcode }, controller.signal)
      .then(result => { if (!controller.signal.aborted) setArticolo(result); })
      .catch(() => { if (!controller.signal.aborted) setErrore(true); })
      .finally(() => clearTimeout(timeout));
    return () => { clearTimeout(timeout); controller.abort(); };
  }, [api, sessioneId, barcode]);

  return <div className="mag-scan-preview" aria-label="Articolo da scansionare">
    <div className="mag-scan-preview-image">
      <div className="mag-scan-image-placeholder" aria-hidden="true"><IconaArticolo/></div>
      {articolo && <ImgArt prodIDps={articolo.prodIDps} imgIDps={articolo.imgIDps} fonte={articolo.fonte}
        codVS={articolo.codice_vs} size="small_default" zoomable={false} imageClassName="mag-scan-image"
        alt={articolo.descrizione || "Articolo della prenotazione"}/>}
    </div>
    <div className="mag-scan-preview-copy">
      {errore ? <p>Anteprima non disponibile. Puoi continuare a scansionare: il barcode verrà comunque verificato.</p>
        : articolo ? <><p className="mag-scan-description">{articolo.descrizione || "Descrizione non disponibile"}</p>
          <p className="f6">{articolo.fonte} {articolo.ordine} · Sped. {articolo.id_spedizione}</p></>
          : <div role="status" aria-label="Caricamento anteprima articolo"><BlockSkeleton height={56}/></div>}
    </div>
  </div>;
}
